<section class="ev" *ngIf="visivel">
  <div class="ev-cartao">
    <div class="ev-cab">
      <div><span class="ev-rot">Evolução da loja</span><b>Fase {{ estado.evolucao.nomeFase }}</b></div>
      <span class="ev-pct">{{ estado.evolucao.pct }}%</span>
    </div>
    <div class="ev-fases">
      <div *ngFor="let f of fases" [class.feita]="f < estado.evolucao.fase" [class.atual]="f === estado.evolucao.fase">
        <i><em [style.width.%]="preenchimento(f)"></em></i><span>{{ nomeFase(f) }}</span>
      </div>
    </div>
    <div class="ev-proximas" *ngIf="estado.evolucao.proximas.length">
      <span>Para avançar:</span>
      <span class="ev-fato" *ngFor="let p of estado.evolucao.proximas">{{ p }}</span>
    </div>
    <div class="ev-acoes" *ngIf="pendeEquipamento || pendeDivulgar">
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="pendeEquipamento" (click)="equipamentosAbertos = !equipamentosAbertos">
        <i class="fas fa-print"></i> {{ equipamentosAbertos ? 'Fechar equipamentos' : 'Extensão e impressora' }}
      </button>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="pendeDivulgar" (click)="copieLink()">
        <i class="far fa-copy"></i> {{ copiado ? 'Link copiado' : 'Copiar o link da loja' }}
      </button>
    </div>
    <app-onb-equipamentos *ngIf="equipamentosAbertos" [estado]="estado" (mudou)="atualize($event)"></app-onb-equipamentos>
  </div>

  <div class="ev-novidade" *ngIf="novas.length">
    <div class="ev-novidade-cab">
      <span class="onb-ic ev-ic-novo"><i class="fas fa-star"></i></span>
      <b>Seu menu cresceu junto com a loja</b>
      <button type="button" class="ev-fechar" (click)="dispenseNovidades()" aria-label="Dispensar"><i class="fas fa-times"></i></button>
    </div>
    <div class="ev-novidade-itens">
      <a *ngFor="let n of novas" [routerLink]="rota(n.id)" (click)="abriuNovidade(n.id)"><b>{{ n.nome }}</b><span>{{ n.descricao }}</span></a>
    </div>
  </div>

  <p class="ev-vem" *ngIf="vemAi">
    <i class="fe-compass"></i> Vem aí no seu menu: <b>{{ vemAi.nomes }}</b> · {{ vemAi.quando.toLowerCase() }}. Quer antes? Abra em Descobrir, no pé do menu.
  </p>
</section>
